import { i18n } from "@lingui/core";

export class SearchFilter {
	pageSize: number = 10
	pageId: number = 0
	orderType: OrderType | null = null
	orderBy: string | null = null

	public static empty = (): SearchFilter => {
		return new SearchFilter()
	}
}

export enum OrderType {
	ASCENDING = "ASCENDING", //
	DESCENDING = "DESCENDING", //
}

export enum SwitchEnum {
	YES = "YES",
	NO = "NO",
	UNINTERESTING = "UNINTERESTING"
}

class SwitchEnumTranslations {
	YES = /*i18n*/i18n._({ id: "enums.switch-enum.YES", message: "Sì" })
	NO = /*i18n*/i18n._({ id: "enums.switch-enum.NO", message: "No" })
	UNINTERESTING = /*i18n*/i18n._({ id: "enums.switch-enum.UNINTERESTING", message: "Indifferente" })
}

export class SwitchUtils {
	public static setSwitchValue = (value: SwitchEnum): boolean | null => {
		switch (value) {
			case SwitchEnum.UNINTERESTING:
				return null
			case SwitchEnum.YES:
				return true
			case SwitchEnum.NO:
				return false
			default:
				return null
		}
	}

	public static setSelectValue = (value: boolean | null): SwitchEnum => {
		switch (value) {
			case null:
				return SwitchEnum.UNINTERESTING
			case true:
				return SwitchEnum.YES
			case false:
				return SwitchEnum.NO
			default:
				return SwitchEnum.UNINTERESTING
		}
	}
}
